/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 자동완성 검색 컴포넌트
 * 버전 : 1.0
 * 파일명 : PromoAutoComplete.ts
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-17, 강동형 : 저작권 추가, 포커스 테두리 색 로직 추가
 * 수정 : 2025-09-16, 강동형 : 포커스 중일 때는 에러 UI반환 안하도록 변경
 * ================================================================ 
 */

import { useState, useEffect, useRef } from "react";
import InputBoxOnChange from "../inputbox/InputBoxOnChange";
import { postSchoolfilter } from "src/api/SchoolService";
import { styled } from "@mui/material";
import { usePromoresultStore } from "src/stores/PromoStore";
import { AlertSpan } from "../common/CommonStyled";

const PageWrapper = styled('div')({
    display:'flex',
    flexDirection:'column',
    width:'100%',
    position:'relative'
    
})

const OptionWrapper = styled('div')({
    display:'flex',
    flexDirection:'column',
    width:'100%',
    border: '1px solid #ccc',
    fontSize: '16px',
    backgroundColor: 'white',
    padding:'10px 20px',
    maxHeight:'150px',
    overflowX:'hidden',
    zIndex:10,
    position:'absolute',
    top:'46px',
    overFlowY:'auto'
})

const OptionContainer = styled('div')({
  margin: '4px 0px'
})

const PromoAutoComplete = () => {
    const [inputValue, setInputValue] = useState("");
    const [highOption, setHighOption] = useState<any[]>([]);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null); // 🔥 timeout 저장할 ref
    const setField = usePromoresultStore((state)=>state.setField)
    const school_id = usePromoresultStore((state)=>state.school_id)
    const [isFocus,setIsFocus] = useState(false)
    const [inputboxValid,setInputboxValid] = useState(true)
    //스쿨클래스 수정 필요
  useEffect(() => {
    // 기존 타이머가 있으면 지워준다
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    // 새 타이머 설정
    timeoutRef.current = setTimeout(async () => {
      if (!inputValue) {
        setHighOption([]);
        return;
      }
      try {
        const response = await postSchoolfilter({page:1,sort_by:'school_name',sort_order:'asc',school_name:inputValue,months_last_visit:0,loc:[["전국",[]]],edu_level:[0],highschool_type:[0],special_note:[0]})
        const data = response.data;
        
        setHighOption(data); // 🔥 결과 저장
      } catch (error) {
        console.error("검색 실패:", error);
      }
    }, 300); // 300ms 뒤에 API 요청

    // unmount 될 때 타이머 클리어
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [inputValue]); // inputValue가 바뀔 때마다 작동

  const onClickChooseSchool = (value:any)=>{
      setInputValue(value.school_name)
      setField('school_id',value.school_id)
      setField('total_cnt',value.total_student_cnt)
      // setField('interested_cnt',value.interested_cnt)
    if(value.school_class === '고등학교'){
      setField('school_class','high')
    }
    else if (value.school_class === '대학교'){
      setField('school_class','univ')
    }
    else { 
      setField('school_class','etc')
    }
    setIsFocus(false)
  }

  const onChangeInputValue = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setField('school_id',0)
    setInputValue(e.target.value)
  }

  const onBlurEvent = ()=>{
    setTimeout(() => setIsFocus(false), 100)
  }
  useEffect(()=>{
    if(isFocus) {
      setInputboxValid(true)
    }
    else if(inputValue === ""){
      setInputboxValid(true)
    }
    else if (school_id !== 0){
      setInputboxValid(true)
    }
    else{
      setInputboxValid(false)
    }
  },[inputValue,school_id,isFocus])
  return (
    <PageWrapper>
      <InputBoxOnChange onChange={onChangeInputValue} value={inputValue} onFocus={() => setIsFocus(true)} onBlur={onBlurEvent} isValid={inputboxValid}/>
      {(inputValue !== "" && school_id === 0 && !isFocus) &&
      <AlertSpan $isValid={false}>드롭다운에서 학교를 선택해주세요.</AlertSpan>
      }
      {/*✅ 포커스되면 열기 */}
      {isFocus &&
        <OptionWrapper>
            {highOption && 
            <div>
                {highOption.map((item,index)=>{
                    return(
                    <OptionContainer onClick={()=>onClickChooseSchool(item)}>
                        {item.school_name}&nbsp;({item.wide_loc})
                    </OptionContainer>
                    )
                })}
            </div>
      }
            {/* {eduOption && 
            <div>
                {eduOption.map((item,index)=>{
                    return(
                    <OptionContainer onClick={()=>onClickChooseSchool(item)}>
                        {item.education_name}&nbsp;({item.address.slice(0,2)})
                    </OptionContainer>
                    )
                })}
            </div>} */}
        </OptionWrapper>
}
    </PageWrapper>
  )
}

export default PromoAutoComplete